import React from 'react'

import { Modal, Button, Col, Row, Tabs, Divider } from '_zari/core'

import { IdGen, DateHandler } from 'utils'

import { AdminContext } from 'contexts/AdminContext'

import * as TiposCambioService from 'services/tiposCambio.service'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const TipoCambioModal = ({ show, handleClose, fechaReferencia }) => {
  const __adminContext = React.useContext(AdminContext)

  const { mesFechaReferencia, anioFechaReferencia } = React.useMemo(() => {
    let salida = {}

    if (fechaReferencia) {
      const splitedFecha = fechaReferencia.split(DateHandler._DIVIDERSYMBOL)
      salida = {
        mesFechaReferencia: splitedFecha[1],
        anioFechaReferencia: splitedFecha[2]
      }
    }

    return salida
  }, [fechaReferencia])

  const [mesSeleccionado, setMesSeleccionado] = React.useState(mesFechaReferencia || __adminContext.mesTrabajo)
  const [anioSeleccionado, setAnioSeleccionado] = React.useState(anioFechaReferencia || __adminContext.anioTrabajo)

  const [tiposCambio, setTiposCambio] = React.useState([])
  const [mostrarTabla, setMostrarTabla] = React.useState(false)
  const [sectionKey, setSectionKey] = React.useState(IdGen.newId())

  const fechaSeleccionada = React.useMemo(() => {
    return `01${DateHandler._DIVIDERSYMBOL}${mesSeleccionado}${DateHandler._DIVIDERSYMBOL}${anioSeleccionado}`
  }, [mesSeleccionado, anioSeleccionado])

  const changeMes = React.useCallback(e => {
    setMesSeleccionado(e.target.value)
    setSectionKey(IdGen.newId())
    setMostrarTabla(false)
  }, [])

  const changeAnio = React.useCallback(e => {
    setAnioSeleccionado(e.target.value)
    setSectionKey(IdGen.newId())
    setMostrarTabla(false)
  }, [])

  const refrescarTiposCambio = React.useCallback(async () => {
    await TiposCambioService.getTiposCambio(fechaSeleccionada).then(({ data }) => {
      setTiposCambio(data)
    })
  }, [fechaSeleccionada])

  const clickBuscar = React.useCallback(async () => {
    await refrescarTiposCambio()
    setMostrarTabla(true)
  }, [refrescarTiposCambio])

  const clickRefrescarViaSunat = React.useCallback(async () => {
    await TiposCambioService.actualizarTiposCambioViaSunat(fechaSeleccionada)
    await refrescarTiposCambio()
    setSectionKey(IdGen.newId())
  }, [fechaSeleccionada, refrescarTiposCambio])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>TIPOS DE CAMBIO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='zari-slim-form'>
          <Col md={4}>
            <FormGroups.MesFormGroup onChange={changeMes} value={mesSeleccionado} />
          </Col>
          <Col md={4}>
            <FormGroups.AnioFormGroup onChange={changeAnio} value={anioSeleccionado} />
          </Col>
          <Col md={3}>
            <Button onClick={clickBuscar}>Buscar</Button>
          </Col>
        </Row>
        <Divider />
        {mostrarTabla && (
          <>
            <Tabs defaultActiveKey='1' id='tabs-tiposcambio'>
              <Tabs.Tab eventKey='1' title='Automático'>
                <Row className='mb-1'>
                  <Col md={12} className='text-right'>
                    <Button tiny onClick={clickRefrescarViaSunat}>
                      Refrescar via SUNAT
                    </Button>
                  </Col>
                </Row>
                <Sections.DetallesTablaAutomaticoSection key={`${sectionKey}-auto`} fechaSeleccionada={fechaSeleccionada} tiposCambio={tiposCambio} />
              </Tabs.Tab>
              <Tabs.Tab eventKey='2' title='Manual'>
                <Sections.DetallesTablaSection key={sectionKey} fechaSeleccionada={fechaSeleccionada} tiposCambio={tiposCambio} />
              </Tabs.Tab>
              <Tabs.Tab eventKey='3' title='Euros'>
                <Sections.DetallesTablaEurosSection key={sectionKey} fechaSeleccionada={fechaSeleccionada} tiposCambio={tiposCambio} />
              </Tabs.Tab>
            </Tabs>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Salir
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(TipoCambioModal)
